//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryCustomers', {
//        templateUrl: 'views/components/views/deliveryCustomers/deliveryCustomers.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'deliveryCustomersService', function ($stateParams, stateService, deliveryCustomersService) {
//            const vm = this;
//            let custNo = $stateParams.cust_no;
            
//            vm.model = {
//                setting: {},
//                itemsListDeliveryCustomers: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await deliveryCustomersService.getSetting({ cust_no: custNo }))[0];
//            }
    		
//            async function loadDeliveryCustomers() {
//                return vm.model.itemsListDeliveryCustomers = await deliveryCustomersService.listDeliveryCustomers(vm.model.setting);
//            }
            
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'deliverycustomer':
//                        go({
//                            deliverycustomer_keyno: '0',
//                            cust_no: vm.model.setting.cust_no
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadDeliveryCustomers();
//            }
//        }]
//    });
//})();
